<template>

    <div class="p-2">
        <label>{{ place }}: </label>

        <vue-typeahead-bootstrap

            showAllResults
            size="sm"
            :placeholder="placeholder"
            v-model="model"
            :serializer="place => place.name"
            :data="pickupData"
            @hit="selected => setPlace(selected)">

            <template #suggestion="{ data, htmlText }">
                <span v-html="htmlText"></span><br /><small>{{
                    data.address
                }}</small>
            </template>

            <template #prepend>
                <a :href="pickupLocationUrl" target="_blank">
                    <b-input-group-text
                        ><md-icon :icon="pickupTypeIcon"
                    /></b-input-group-text>
                </a>
            </template>

            <template #append>
                <b-button variant="primary">
                    <b-spinner v-if="pickupLoading" small />
                    <span v-else><md-icon icon="edit"></md-icon></span>
                </b-button>
				<b-button variant="success" v-if="!$root.isEmpty(placeSelected)">
                    <span><md-icon icon="check"></md-icon></span>
                </b-button>
				<b-button variant="warning" v-else class="__shake">
                    <span><md-icon icon="info"></md-icon></span>
                </b-button>
            </template>
        </vue-typeahead-bootstrap>
		<!----<a :href="pickupLocationUrl" target="_blank" v-if="!$root.isEmpty(placeSelected)"> <md-icon icon="location_on"/>{{$t("global.seeLocation") }}</a>--->
    </div>

</template>

<script>
    import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
    import { debounce } from "debounce";

    export default {
        components: {VueTypeaheadBootstrap},
        props: {
            place: String,
            placeholder: String,
            value: [String, Object]
        },
        data() {
            return {
                pickupData: [],
                pickupLoading: false,
                isAirport: false,
                result: null,
				placeSelected:null
            }
        },
        computed: {
            model: {
                get() {
                    return this.value
                },
                set(v) {
                    this.$emit('input', v)
                }
            },
             pickupTypeIcon() {
                let icon = "location_on";
                if (this.isAirport) icon = "flight";
                return icon;
            },
            pickupLocationUrl() {
                if (this.result != null) {
                    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        this.result.name
                    )}`
                }

                return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    this.place
                )}`
            },
        },
         watch: {
            model: debounce(function(term) {
                this.searchPlace("pickup", term);
            }, 500)
        },
        methods: {
			setPlace(place) {
                this.result          = place
                if (place.isAirport) {
                    this.isAirport   = place.isAirport
                }
				this.placeSelected= place;
				this.model        = this.placeSelected.name
                this.$emit('getData', {index: this.place, match: place})
            },
            searchPlace(attrName, term , selectIfUnique=false) {
                if (term != "") {
                    this[`${attrName}Loading`] = true;
                    this.$root.api
                        .post(`/places/search`, { term })
                        .then(res => {
                            this[`${attrName}Data`] = res.data;
                            this[`${attrName}Loading`] = false;
							if(selectIfUnique){
								if(res.data.length==1){
									this.setPlace(res.data[0])
								}
							}
                        })
                        .catch(err => {
                            console.log(err);
                            this[`${attrName}Loading`] = false;
                        });
                }
            },
        },
		mounted(){
			setTimeout(()=>{
				this.model = this.place;
				this.searchPlace("pickup",this.place,true);
			},0)

		}
    }

</script>
